import { Path } from "app/path";
import http from "app/requests/axiosInstance";
import { getFormValues } from "app/utils/getFormValues";
import { useQuery } from "app/utils/useQuery";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const useResetPassword = () => {
  const query = useQuery();
  const resetToken = query.get("token");
  const navigate = useNavigate();
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [user, setUser] = useState<any>();

  const onSubmit = async (e: any) => {
    e.preventDefault();
    const { password, passwordConfirmation } = getFormValues(e.target);

    if (password.length < 8) {
      return toast.error("Password must be at least 8 characters long");
    }
    if (password !== passwordConfirmation) {
      return toast.error("Passwords do not match");
    }

    setIsSubmitting(true);
    try {
      await http.post("/v1/auth/reset-password", {
        token: resetToken,
        password,
      });
      toast.success("Password updated, please log in with your new password.");
      navigate(Path.LOGIN);
    } catch (error: any) {
      toast.error(
        error?.data?.error ?? "Something went wrong. Please try again."
      );
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const validateToken = async () => {
    setIsLoading(true);
    try {
      const { data } = await http.post("/v1/auth/reset-password/validate", {
        token: resetToken,
      });
      setUser(data);
      setIsTokenValid(true);
    } catch (error: any) {
      setIsTokenValid(false);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!resetToken) {
      setIsLoading(false);
      setIsTokenValid(false);
      return;
    }
    validateToken();
  }, [resetToken]);

  return {
    isTokenValid,
    isLoading,
    isSubmitting,
    user,
    onSubmit,
  };
};
